export function topicLibraryPath({ tab, search } = {}) {
  const params =
    search instanceof URLSearchParams
      ? new URLSearchParams(search)
      : new URLSearchParams(search || "");
  if (tab) params.set("tab", tab);
  const query = params.toString();
  return query ? `/settings/topic-library?${query}` : "/settings/topic-library";
}
